<template>
  <div class="userWatch-box">
    <!--操作栏-->
    <div class="action-bar flex align-item-baseline">
      <el-select placeholder="观看方式" size="small" v-model="params.playWay" @change="getWatchLog('status')" clearable>
        <el-option v-for="item in methodList" :key="item.value" :value="item.value" :label="item.label"></el-option>
      </el-select>
      <el-input placeholder="请输入渠道码" size="small" clearable @keyup.enter.native="getWatchLog('qcode')" class="param-input" v-model="params.qcode"></el-input>
      <el-input placeholder="请输入用户ID" size="small" clearable @keyup.enter.native="getWatchLog('status')" class="param-input" v-model="params.uid"></el-input>
      <div class="flex">
        <el-date-picker v-model="time" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" size="small" @change="changeTime"></el-date-picker>
        <div class="ml-5"><el-button type="primary"  size="small" @click="getWatchLog('status')">搜索</el-button></div>
      </div>
    </div>
    <!--表格数据-->
    <el-table :data="tableData" style="width: 100%" border v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" ref="multipleTable">
      <el-table-column prop="createdAt" label="添加时间" align="center" min-width="140">
        <template slot-scope="scope">
          <span>{{scope.row.createdAt | changeDate}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="qcode" label="渠道码" align="center" min-width="68" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{scope.row.qcode }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="uid" label="用户ID" align="center" min-width="68">
        <template slot-scope="scope">
          <span>{{scope.row.uid || '未知'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="title" label="视频ID" align="center" show-overflow-tooltip min-width="192">
        <template slot-scope="scope">
          {{scope.row.videoID}}
        </template>
      </el-table-column>
      <el-table-column prop="playUrl" label="M3U8地址" align="center" show-overflow-tooltip min-width="80">
        <template slot-scope="scope">
          <a :href="scope.row.playUrl" target="_blank" style="color:#333">{{scope.row.playUrl}}</a>
        </template>
      </el-table-column>
      <el-table-column prop="title" label="视频类型" align="center" show-overflow-tooltip min-width="80">
        <template slot-scope="scope">
          <span v-if="scope.row.videoType == 1">免费视频</span>
          <span v-if="scope.row.videoType == 2">金币视频</span>
          <span v-if="scope.row.videoType == 3">VIP视频</span>
        </template>
      </el-table-column>
      <el-table-column prop="title" label="视频标题" align="center" show-overflow-tooltip min-width="120">
        <template slot-scope="scope">
          <span>{{scope.row.title || '未知'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="palyMethod" label="观看方式" align="center" min-width="80">
        <template slot-scope="scope">
          <span>{{scope.row.playWay | playRule }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="devType" label="观看设备" align="center" min-width="100">
        <template slot-scope="scope">
          <span>{{scope.row.devType == 'ios'?'iphone':"安卓" }}/{{scope.row.appVersion || '1.0.0'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="devType" label="观看IP" align="center" min-width="120" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{scope.row.ip }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="cityName" label="观看地区" align="center" min-width="120" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{scope.row.cityName || "未知"}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="progress" label="观看进度" min-width="110" align="center">
        <template slot-scope="scope">
          <el-progress :percentage="scope.row.progress"></el-progress>
        </template>
      </el-table-column>
      <el-table-column prop="longer" label="停留时长" min-width="90" align="center">
        <template slot-scope="scope">
          <span>{{scope.row.longer | changeSecond}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="playTime" label="播放秒数" align="center" show-overflow-tooltip min-width="72">
        <template slot-scope="scope">
          {{scope.row.playTime || 0}}
        </template>
      </el-table-column>
      <el-table-column prop="totalTime" label="总时长" min-width="70" align="center">
        <template slot-scope="scope">
          <span>{{scope.row.totalTime | changeSecond}}</span>
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <el-pagination :page-sizes="[ 10, 15, 20, 25]"
                   :current-page="params.pageNumber"
                   :page-size="params.pageSize"
                   layout="total, sizes, prev, pager, next, jumper"
                   :total="total"
                   background
                   @size-change="changeSize"
                   @current-change="changeCurrent"></el-pagination>
  </div>
</template>
<script>
import {changeTime} from '@/utils/global'
import API from '@/api'

export default {
  data() {
    return {
      tableData: [],
      time: '',
      loading: false,
      total: 0,
      methodList: [
        { value: 1, label: '免费观看' },
        { value: 2, label: '付费观看' },
        { value: 3, label: '试看' },
      ],
      // 请求订单列表参数
      params: {
        pageNumber: 1,
        pageSize: 18,
        key: '',
        value: '',
        palyMethod: '',
        uid: '',
        startTime: '',
        endTime: '',
      }
    }
  },
  created() {
    this.getWatchLog()
  },
  filters: {
    playRule: value => {
      if (value != 0 && !value) {
        return '未知'
      }
      let valueList = ['免费观看', '付费观看', '试看']
      return valueList[value]
    },
  },
  methods: {
    // 时间选择回掉
    changeTime(time) {
      if (time) {
        this.params.start = changeTime(time[0])
        this.params.end = changeTime(time[1])
      } else {
        this.params.start = ''
        this.params.end = ''
      }
      this.getWatchLog('status')
    },
    // 请求订单列表
    getWatchLog(type) {
      this.loading = true
      if (type === "status") {
        this.params.pageNumber = 1
      }
      API.getWatchLog(this.params).then(res => {
        if (res.code === 200 && res.data.logs) {
          this.tableData = res.data.logs
          this.total = res.data.total
        } else {
          this.tableData = []
          this.total = 0
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    // 分页条数改变回掉
    changeSize(size) {
      this.params.pageSize = size
      this.getWatchLog()
    },
    // 分页页码改变回掉
    changeCurrent(number) {
      this.params.pageNumber = number
      this.getWatchLog()
    },
  }
}
</script>
